"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewCycleCalculateHandlerEvent", {
    enumerable: true,
    get: function() {
        return ReviewCycleCalculateHandlerEvent;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewCycleCalculateHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId,
    actions: _zod.z.enum([
        "unassigned-reports",
        "status"
    ]).array()
});
